const auth_status = {
    page_title: '認證狀態',
    title: '認證狀態',
    description: '檢查認證的狀態。',
};
export default Object.freeze(auth_status);
